<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import userAuthStore from '@/store/userAuthStore';
import entityStore from '@/store/entityStore';

export default {
  name: 'app',
  data() {
    return {
      userAuth: userAuthStore.state,
      entity: entityStore.state,
    };
  },
  created() {
    this.getCookie();
    this.fetchEntity();
  },
  watch: {
    userAuth: {
      handler(val) {
        if (!val.loggedIn) {
          this.$router.push('/login');
        }
      },
      deep: true,
    },
  },
  methods: {
    getCookie() {
      const path = `${location.hostname}`;
      const token = this.$cookie.get('token', { domain: path });
      if (token) {
        userAuthStore.logIn(token);
        // redirect user to dashboard
        this.$router.push('/my');
      }
    },
    fetchEntity() {
      const path = `${location.hostname}`;
      switch (path) {
        case 'mijn.amicitia.nl':
          this.entity.name = 'amicitia';
          this.entity.label = 'Amicitia Reizen';
          this.entity.tel = '078 - 6845353';
          this.entity.telInt = '0031 - 78 6845353';
          this.entity.id = 1;
          this.entity.bgImgClass = 'amicitia-bg';
          this.entity.mailAddress = 'info@amicitia.nl';
          this.entity.website = 'www.amicitia.nl';
          this.entity.websiteLink = 'http://amicitia.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 264';
          this.entity.postboxAddress = '3340 AG Hendrik-Ido-Ambacht';
          break;
        case 'mijn.friendshipcruises.nl':
          this.entity.name = 'friendshipcruises';
          this.entity.label = 'Friendship Cruises';
          this.entity.tel = '+31 (0)88 - 13 07 300';
          this.entity.telInt = '';
          this.entity.id = 2;
          this.entity.bgImgClass = 'friendshipcruises-bg';
          this.entity.mailAddress = 'info@friendshipcruises.nl';
          this.entity.website = 'www.friendshipcruises.nl';
          this.entity.websiteLink = 'http://friendshipcruises.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 7';
          this.entity.postboxAddress = '3340 AA Hendrik-Ido-Ambacht';
          break;
        case 'mijn.hannick.nl':
          this.entity.name = 'hannick';
          this.entity.label = 'Hannick Reizen B.V.';
          this.entity.tel = '070 - 3191929';
          this.entity.telInt = '0031 - 70 3191929';
          this.entity.id = 3;
          this.entity.bgImgClass = 'hannick-bg';
          this.entity.mailAddress = 'info@hannick.nl';
          this.entity.website = 'www.hannick.nl';
          this.entity.websiteLink = 'http://hannick.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 165';
          this.entity.postboxAddress = '3340 AD Hendrik-Ido-Ambacht';
          break;
        case 'mijn.amigoreizen.nl':
          this.entity.name = 'amigo';
          this.entity.label = 'AmiGO Reizen';
          this.entity.tel = '078 - 6845350';
          this.entity.telInt = '0031 - 78 6845350';
          this.entity.id = 6;
          this.entity.bgImgClass = 'amigo-bg';
          this.entity.mailAddress = 'info@amigoreizen.nl';
          this.entity.website = 'www.amigoreizen.nl';
          this.entity.websiteLink = 'http://amigoreizen.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 264';
          this.entity.postboxAddress = '3340 AG Hendrik-Ido-Ambacht';
          break;
        case 'mijn.davincitravel.nl':
          this.entity.name = 'davincitravel';
          this.entity.label = '';
          this.entity.tel = '';
          this.entity.telInt = '';
          this.entity.id = 8;
          this.entity.bgImgClass = '';
          this.entity.mailAddress = '';
          this.entity.website = '';
          this.entity.postcodeCity = '';
          this.entity.postbox = '';
          this.entity.postboxAddress = '';
          break;
        case 'mijn.aircruise.nl':
          this.entity.name = 'aircruise';
          this.entity.label = 'Air Cruise Collection';
          this.entity.tel = '+ 31 (0) 88 130 73 80';
          this.entity.telInt = '';
          this.entity.id = 5;
          this.entity.bgImgClass = 'aircruise-bg';
          this.entity.mailAddress = 'info@aircruisecollection.nl';
          this.entity.website = 'www.aircruisecollection.nl';
          this.entity.websiteLink = 'http://aircruisecollection.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = '';
          this.entity.postboxAddress = '';
          break;
        case 'mijn.ncrv-reizen.nl':
        case 'mijn.ncrvreizen.nl':
          this.entity.name = 'ncrv-reizen';
          this.entity.label = 'NCRV Reizen';
          this.entity.tel = '088 - 1307360';
          this.entity.telInt = '0031 - 88 1307360';
          this.entity.id = 10;
          this.entity.bgImgClass = 'ncrv-reizen-bg';
          this.entity.mailAddress = 'info@ncrv-reizen.nl';
          this.entity.website = 'www.ncrv-reizen.nl';
          this.entity.websiteLink = 'http://ncrv-reizen.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 7';
          this.entity.postboxAddress = '3340 AG Hendrik-Ido-Ambacht';
          break;
        case 'mijn.agroreizen.nl':
          this.entity.name = 'agro';
          this.entity.label = 'Agro reizen';
          this.entity.tel = '026 351 20 87';
          this.entity.telInt = '+31 (0)26 351 20 87';
          this.entity.id = 11;
          this.entity.bgImgClass = 'agro-bg';
          this.entity.mailAddress = 'info@agroreizen.nl';
          this.entity.website = 'www.agroreizen.nl';
          this.entity.websiteLink = 'https://agroreizen.nl';
          this.entity.postcodeCity = '6811 JL  ARNHEM';
          this.entity.postbox = '';
          this.entity.postboxAddress = '';
          break;
        default:
          this.entity.name = 'amigo';
          this.entity.label = 'AmiGO Reizen';
          this.entity.tel = '078 - 6845350';
          this.entity.telInt = '0031 - 78 6845350';
          this.entity.id = 6;
          this.entity.bgImgClass = 'amigo-bg';
          this.entity.mailAddress = 'info@amigoreizen.nl';
          this.entity.website = 'www.amigoreizen.nl';
          this.entity.websiteLink = 'http://amigoreizen.nl';
          this.entity.postcodeCity = '3341 LL Hendrik-Ido-Ambacht';
          this.entity.postbox = 'Postbus 264';
          this.entity.postboxAddress = '3340 AG Hendrik Ido Ambacht';
          break;
        }
      this.entity.banner = `${this.entity.name}-banner`;
    },
  },
};
</script>

<style lang="scss">
@import './main.scss';

body {
  font-family: Roboto !important;
  background-color: #ececec;
  position: relative;
  margin: 0;
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// App.vue?4453251c